import React, { FC } from 'react';
export interface IConfigWraperProps {}

export const withConfigWraper =
  (Component: FC<IConfigWraperProps>) => (props: IConfigWraperProps) => {
    return (
      <div className='withConfigWraper'>
        <div className='TabLinks'>
          {/* <NavLink to={Routes.withdrawConfig.path} >
                    <Icon.Setting />
                    Withdraw Config
                </NavLink> */}

          {/* <NavLink to={Routes.maintenanceConfig.path} >
                    <Icon.MaintenanceIcon />
                    Maintenance Config
                </NavLink> */}

          {/* <NavLink to={Routes.ChangePassword.path}>
          <Icon.ChangePasswordIcon />
          Change Password
        </NavLink> */}

          {/* <NavLink to={Routes.Announcement.path} >
                  <Icon.Setting />
                  Announcement
                </NavLink> */}
        </div>

        <Component {...props} />
      </div>
    );
  };
